export const localStorageKeys = {
  auth: '@codilo/token',
};
